import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  padding: 10px 30px 30px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  width: 100%;

  @media (max-width: 767px) {
    position: relative;
    padding: 16px;
    .leftSide {
      flex-wrap: wrap;
      gap: 12px;
    }
    .leftSide button {
      margin: 0;
    }
  }

  button {
    padding: 9px 15px;
    min-width: 130px;
  }

  .leftSide {
    display: flex;

    button {
      flex: 0 0 auto;
      margin: 0 30px 0 0;
      width: auto;
    }
  }
`;
